module.exports = __webpack_public_path__ + "static/img/img03.4694cea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/en/en001/img03.jpg
// module id = ERTs
// module chunks = 0